import { render, staticRenderFns } from "./close-square.vue?vue&type=template&id=557df22e&"
import script from "./close-square.vue?vue&type=script&lang=js&"
export * from "./close-square.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports